"use client";
import axios from "../../app/lib/axiosInstance";
import { Poppins } from "next/font/google";
import Image from "next/image";
import { useParams } from "next/navigation";
import { useEffect, useState } from "react";
import { Rating } from "react-simple-star-rating";

const poppins = Poppins({
  subsets: ["latin"],
  weight: ["400", "500", "600", "700", "800", "900"],
});

const Avis = () => {
  const [avis, setAvis] = useState([]);
  const params = useParams();
  const getProductAvis = async () => {
    const data = await axios
      .get(`/avis/getproductavis/${params.id}`)
      .then((res) => res.data)
      .then((res) => res.avisData)
      .then((res) => setAvis(res))
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    getProductAvis();
  }, []);
  return (
    <>
    
        {avis.length>2?   
        <div className={poppins.className}>
        <h2 className="md:text-[30px] font-semibold text-center my-12 md:my-20">
          Nos clients témoignent leurs confiance
        </h2>
        <div className="flex justify-between items-center flex-row gap-12 md:gap-auto overflow-x-scroll md:overflow-auto">

            <div className="relative h-[314px] rounded-[27px] max-w-[260px]  min-w-[260px] border-[1px] border-[#707070]">
              <Image
                src={"/aa.png"}
                width={500}
                height={500}
                className="rounded-[45%] w-[110px] h-[110px] object-cover absolute -top-[55px] right-[30%]"
              />
              <div className="w-4/5 mx-auto mt-16 flex flex-col justify-between items-center h-[75%]">
                <h2 className="text-center text-[16px] font-semibold text-[#9B9B9B]">
                 {avis[0]?.owner?.name}
                </h2>
                <h3 className="text-[14px] text-[#5E5E5E]">
                {avis[0]?.avis}
                </h3>
                <Rating
                  emptyColor={"#dbc9c8"}
                  allowHover={false}
                  initialValue={avis[0]?.rate}
                  size={36}
                  value={avis[0]?.rate}
                  fillColor={"#000000"}
                  SVGstyle={{ display: "inline" }}
                />
              </div>
            </div>
             
            <div className="relative h-[447px] rounded-[27px] max-w-[352px] min-w-[352px] border-[1px] border-[#707070]">
              <Image
                src={"/aa.png"}
                width={500}
                height={500}
                className="rounded-[45%] w-[110px] h-[110px] object-cover absolute -top-[55px] right-[35%]"
              />
              <div className="w-4/5 mx-auto mt-16 flex flex-col justify-between items-center h-[75%]">
                <h2 className="text-center text-[16px] font-semibold text-[#9B9B9B]">
                {avis[1]?.owner?.name}
                </h2>
                <h3 className="text-[14px] text-[#5E5E5E]">
                {avis[1]?.avis}
                </h3>
                <Rating
                  emptyColor={"#dbc9c8"}
                  allowHover={false}
                  initialValue={avis[1]?.rate}
                  size={36}
                  value={avis[1]?.rate}
                  fillColor={"#000000"}
                  SVGstyle={{ display: "inline" }}
                />
              </div>
            </div>

          <div className="relative h-[314px] rounded-[27px] max-w-[260px] min-w-[260px] border-[1px] border-[#707070]">
            <Image
              src={"/aa.png"}
              width={500}
              height={500}
              className="rounded-[45%] w-[110px] h-[110px] object-cover absolute -top-[55px] right-[30%]"
            />
            <div className="w-4/5 mx-auto mt-16 flex flex-col justify-between items-center h-[75%]">
              <h2 className="text-center text-[16px] font-semibold text-[#9B9B9B]">
              {avis[2]?.owner?.name}
              </h2>
              <h3 className="text-[14px] text-[#5E5E5E]">
              {avis[2]?.avis}
              </h3>
              <Rating
                emptyColor={"#dbc9c8"}
                allowHover={false}
                initialValue={avis[2]?.rate}
                size={36}
                value={avis[2]?.rate}
                fillColor={"#000000"}
                SVGstyle={{ display: "inline" }}
              />
            </div>
          </div>
        </div>
      </div>
    :
    null  
    }
      
    </>
  );
};

export default Avis;
